import { Typography } from '@progress/kendo-react-common';
import { KWELLO_ICON, KwelloSvgIcon } from '../icon/KwelloSvgIcon';
import { Avatar, CardHeader } from '@progress/kendo-react-layout';

import { DATE_FORMAT } from '../../constants';
import { formatAppDate, generateAvatarInitials } from '../../hooks/utils';

interface Row {
  date: Date;
  fieldTeam: string;
  profile: string;
}

export function TabCardHeader({
  row,
  isTeamMember,
}: Readonly<{ row: Row; isTeamMember: boolean }>) {
  const name = isTeamMember ? row.profile : row.fieldTeam;
  return (
    <CardHeader>
      <div className="insights-card-header">
        <div className="card-header-left">
          <KwelloSvgIcon icon={KWELLO_ICON.CALENDAR_ICON} />
          {formatAppDate(new Date(row.date), DATE_FORMAT)}
        </div>
        {name && (
          <div className="card-header-right">
            <Avatar rounded="full" type={'text'}>
              {generateAvatarInitials(name)}
            </Avatar>
            <Typography.p>{name}</Typography.p>
          </div>
        )}
      </div>
    </CardHeader>
  );
}
